import { GridCellParams } from '@/components/custom/erp';
import React, { useMemo } from 'react';
import { InputTable, RepeatRowsPayload } from '@/components/custom/erp';
import InputTableActionBar from '../../InputTableActionBar';
import { SelectedCellInfo } from '../hooks/useTaxRows';
import { copyCellValue } from '@/lib/table-handlers';
import { useTaxPaste } from '../hooks/useTaxPaste';
import { getTaxColumns } from './columns';
import { FormMode } from '@/types/form';

interface TaxTabProps {
  mode: FormMode;
  rows: any[];
  selectedRowUuid?: string | null;
  selectedCell?: SelectedCellInfo | null;
  onRowClick?: (params: any) => void;
  onCellClick?: (params: GridCellParams) => void;
  onAddRow: () => void;
  onDeleteRow: () => void;
  onCopyRow: () => void;
  onPasteRow: (clipboardText?: string) => void | Promise<void>;
  onMoveRow: (direction: 'up' | 'down') => void;
  onExport: () => void;
  onPin: () => void;
  onCellValueChange: (rowUuid: string, field: string, newValue: any) => void;
  onRepeatForRows: (payload: RepeatRowsPayload<any>) => void;
  handleUpdateNonWritableFields?: (fields: Set<string>) => void;
  handleUpdatePasteConfigs?: (
    configs: Record<string, { resolver: (codes: string[]) => Promise<any[]>; resultField?: string }>
  ) => void;
  isPasting?: boolean;
}

const TaxTab: React.FC<TaxTabProps> = ({
  mode,
  rows,
  selectedRowUuid,
  selectedCell,
  onRowClick,
  onCellClick,
  onAddRow,
  onDeleteRow,
  onCopyRow,
  onPasteRow,
  onMoveRow,
  onExport,
  onPin,
  onCellValueChange,
  onRepeatForRows,
  handleUpdateNonWritableFields,
  handleUpdatePasteConfigs,
  isPasting
}) => {
  const columns = useMemo(() => getTaxColumns(mode, onCellValueChange), [mode, onCellValueChange]);

  useTaxPaste({
    columns,
    handleUpdateNonWritableFields,
    handleUpdatePasteConfigs
  });

  return (
    <InputTable
      rows={rows}
      autoHeight
      bottomSelector='[data-arito-bottom-bar]'
      onRowClick={onRowClick}
      onCellClick={onCellClick}
      selectedRowId={selectedRowUuid || undefined}
      columns={columns}
      getRowId={row => row?.uuid || ''}
      enableContextMenu={true}
      onCopyData={({ columnField, columnValue, columnValues }) => {
        copyCellValue({
          columnField,
          columnValue,
          columnValues,
          fallback: text => console.log('Copy data per column:', text)
        });
      }}
      onRepeatForRows={onRepeatForRows}
      actionButtons={
        <InputTableActionBar
          mode={mode}
          selectedCell={selectedCell}
          handleAddRow={onAddRow}
          handleDeleteRow={onDeleteRow}
          handleCopyRow={onCopyRow}
          handlePasteRow={onPasteRow}
          handleMoveRow={onMoveRow}
          handleExport={onExport}
          handlePin={onPin}
          isPasting={isPasting}
        />
      }
    />
  );
};

export default TaxTab;
